import { render } from "./WizardResults.vue?vue&type=template&id=17176dea"
import script from "./WizardResults.vue?vue&type=script&lang=js"
export * from "./WizardResults.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/wizard/WizardResults.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "17176dea"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('17176dea', __exports__)) {
    api.reload('17176dea', __exports__)
  }
  
  module.hot.accept("./WizardResults.vue?vue&type=template&id=17176dea", () => {
    api.rerender('17176dea', render)
  })

}


export default __exports__